import { render, staticRenderFns } from "./ContentAdminSearch.vue?vue&type=template&id=5039ef0a"
import script from "./ContentAdminSearch.vue?vue&type=script&lang=js"
export * from "./ContentAdminSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports